import React from "react"
import { render, fireEvent, cleanup, waitFor } from "@testing-library/react"
import userEvent from "@testing-library/user-event"
import ModalUpdateStatus from "../index"

afterEach(cleanup)

describe("<ModalUpdateStatus />", () => {
  it("does not render status modal by default", () => {
    const { queryByText } = render(<ModalUpdateStatus />)
    expect(queryByText("Update the Plan Status")).not.toBeInTheDocument()
  })
  it("properly displays status modal", () => {
    const { queryByText } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )
    expect(queryByText("Update the Plan Status")).toBeInTheDocument()
  })
  it("opens modal when trigger button clicked", () => {
    const { queryByText } = render(
      <ModalUpdateStatus shouldShowTriggerButton={true} buttonText="Launch Modal" />
    )

    fireEvent.click(queryByText("Launch Modal"))

    expect(queryByText("Update the Plan Status")).toBeInTheDocument()
  })
  it("closes modal when user indicates there is no update", async () => {
    const { queryByText } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    fireEvent.click(queryByText("No update"))

    await waitFor(() =>
      expect(queryByText("Update the Plan Status")).not.toBeInTheDocument()
    )
  })
  it("displays validation message properly when trying to submit", async () => {
    const { getByTestId, queryByText } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    fireEvent.submit(getByTestId("status-form"))
    await waitFor(() => queryByText("This field is required"))

    // ensure that the form is still visible / displayed
    expect(queryByText("Update the Plan Status")).toBeInTheDocument()
  })

  it("does not allow form to be submitted by default", async () => {
    const { getByTestId } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    // button is disabled before form change
    expect(
      getByTestId("status-submit").lastElementChild.querySelector("button")
    ).toBeDisabled()
  })

  it("allows form to be submitted when any field changes", async () => {
    const { getByLabelText, getByTestId } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    userEvent.type(getByLabelText("Comments"), "hi")

    await waitFor(() => {
      fireEvent.submit(getByTestId("status-form"))
      expect(getByTestId("status-form")).not.toBeDisabled()
    })
  })

  it("clears validation message properly", async () => {
    const { getByLabelText, getByTestId, queryByText } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    // update form el to a valid value
    fireEvent.change(getByLabelText("Update Status"), {
      target: { value: "In progress" }
    })

    fireEvent.submit(getByTestId("status-form"))
    await waitFor(() =>
      expect(queryByText("This field is required")).not.toBeInTheDocument()
    )
  })
  it("submits form when valid", async () => {
    const { getByLabelText, getByTestId } = render(
      <ModalUpdateStatus shouldOpenModalByDefault={true} />
    )

    userEvent.type(getByLabelText("Comments"), "hi")

    await waitFor(() => {
      fireEvent.submit(getByTestId("status-form"))
      expect(getByTestId("status-form")).not.toBeDisabled()
    })
  })
})
